export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";